import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxFont = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.307 4L5.30701 20H7.44401L9.31901 15H15.682L17.557 20H19.694L13.694 4H11.307ZM10.068 13L12.5 6.515L14.932 13H10.068Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxFont);
export default Memo;